'use strict';

var app = angular.module('app');

// Service for checkout the shopping cart to paypal or other sites.
app.factory('checkoutService', ["$location", function ($location) {


    function checkoutPayPal(merchantID,orderId,amount,ipnRoute) {
        // global data
        var data = {
            cmd: '_cart',
            business: merchantID,
            upload: '1',
            rm: '1',
            charset: 'utf-8'
        };

        data['item_name_1'] = "Order #"+orderId;
        data['quantity_1'] = 1;
        data['amount_1'] = amount;

        // build form
        var form = $('<form/></form>');
        form.attr('action', 'https://www.paypal.com/cgi-bin/webscr');
        form.attr('method', 'POST');
        form.attr('style', 'display:none;');
        setConfigForm(form,orderId,ipnRoute);
        addFormFields(form, data);
        $('body').append(form);

        // submit form
        form.submit();
        form.remove();
    };

    function addFormFields(form, data) {
        if (data != null) {
            $.each(data, function (name, value) {
                if (value != null) {
                    var input = $('<input></input>').attr('type', 'hidden').attr('name', name).val(value);
                    form.append(input);
                }
            });
        }
    };

    function setConfigForm(form,orderId,ipnRoute) {
        var input = $('<input></input>').attr('type', 'hidden').attr('name','currency_code').val("EUR");
        form.append(input);
        var input = $('<input></input>').attr('type', 'hidden').attr('name','custom').val(orderId);
        form.append(input);
        var input = $('<input></input>').attr('type', 'hidden').attr('name','return').val($location.absUrl().replace("#/cart","#/complete"));
        form.append(input);
        var input = $('<input></input>').attr('type', 'hidden').attr('name','notify_url').val(ipnRoute);
        form.append(input);
    }

    return {
        checkout: function (serviceName, merchantID,orderId,amount,ipnRoute) {
            if (serviceName === 'PayPal') {
                checkoutPayPal(merchantID,orderId,amount,ipnRoute);
            } else {
                throw 'Unknown checkout service: ' + serviceName;
            }
        }
    };
}]);
